module.exports = __webpack_public_path__ + "8e6a3963044eee474533d0df746f0932.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarChloe2.png
// module id = 27
// module chunks = 0